<template>
  <component
    :is="props.blok.heading ? 'article' : 'div'"
    v-editable="props.blok"
    :data-uid="props.blok._uid"
    class="sepac-section-trust-item"
  >
    <div class="top">
      <header v-if="props.blok.heading">
        <h3>{{ props.blok.heading }}</h3>
      </header>
      <div>
        <SepacRichtextResolver :blok="props.blok.copy" />
      </div>
    </div>
    <div class="content">
      <StoryblokComponent v-for="currentBlok in props.blok.widgets" :key="currentBlok._uid" :blok="currentBlok" />
    </div>
    <footer>
      <Button v-for="button in props.blok.btns" :key="button._uid" :blok="button" />
    </footer>
  </component>
</template>

<script setup>
import { WPElementButton } from '@webcarelbj/shared-bloks'
import { findComponent } from '@webcarelbj/shared-components'

const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
})

const Button = findComponent(WPElementButton)
</script>

<style scoped>
.sepac-section-trust-item {
  display: grid;
  gap: 2rem;
  padding-block-end: 1rem;

  & .top {
    display: grid;
    gap: 1.33rem;
  }

  & .content {
    display: grid;
    gap: 6rem 3rem;
  }

  & .content:has(.tuev-widget.without-criteria):has(.trustpilot-widget) {
    grid-template-columns: 1fr 1fr;

    @media (width < 810px) {
      grid-template-columns: 1fr;
    }

    &:has(.micro-combo) .tuev-widget :deep(figure) {
      height: 100%;
    }
    
    & .tuev-widget {
      @media (width >= 810px) {
        padding-inline: 0;
      }

      & :deep(figure) {
        grid-template-columns: 1fr;
      }
    }

    & :deep(figcaption) {
      margin-top: auto;
    }
  }
}

@media (width < 576px) {
  footer {
    text-align: center;
  }
}
</style>